import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { NgIconsModule } from '@ng-icons/core';
import { provideHttpClient, withFetch } from '@angular/common/http';
import * as heroicons from '@ng-icons/heroicons/outline';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }), 
    provideRouter(routes),
    provideClientHydration(withEventReplay()),
    importProvidersFrom(NgIconsModule.withIcons(heroicons)), 
    provideHttpClient(withFetch()),
  ]
};